// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 689 ? "b536a0f1" : chunkId) + "." + {"84":"898270ead15d11e5","607":"465824f75bf25380","689":"c6a72d97133612c8"}[chunkId] + ".js";
};